export const ADD_JOB = 'JIM/ADD_JOB';
export const ADD_JOB_SUCCESS = 'JIM/ADD_JOB_SUCCESS';
export const ADD_JOB_FAILURE = 'JIM/ADD_JOB_FAILURE';
export const FETCH_JOBS = 'JIM/FETCH_JOBS';
export const FETCH_JOBS_SUCCESS = 'JIM/FETCH_JOBS_SUCCESS';
export const FETCH_JOBS_FAILURE = 'JIM/FETCH_JOBS_FAILURE';

export const MARK_JOB_NOTIFICATIONS_AS_SEEN = 'JIM/MARK_JOB_NOTIFICATIONS_AS_SEEN';
